export * from './static-routing.module';
export * from './static.module';
export * from './home/home.component';
